module.exports = __webpack_public_path__ + "static/img/RASM1000-120_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RASM1000-120_1.png
// module id = VEhr
// module chunks = 0